import { render, staticRenderFns } from "./singleJoin.vue?vue&type=template&id=748ef7e1&scoped=true&"
import script from "./singleJoin.vue?vue&type=script&lang=js&"
export * from "./singleJoin.vue?vue&type=script&lang=js&"
import style0 from "./singleJoin.vue?vue&type=style&index=0&id=748ef7e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748ef7e1",
  null
  
)

export default component.exports